import React, { FC, useState } from 'react'

import { css } from '@emotion/core'
import { useTheme } from 'emotion-theming'

import Container from 'components/layouts/atoms/Container'
import NewTypography from 'components/common/atoms/NewTypography'
import Separator from 'components/common/atoms/Separator'
import SeoText from './seo_text.json'
import MarkdownContent from 'components/common/atoms/MarkdownContent'
import Ellipsis from 'components/common/atoms/Ellipsis'
import TextLink from 'components/common/atoms/TextLink'

const kampuspediaSeoTextStyle = (theme: ThemeType) => css`
  background-color: ${theme.gray.gray10};
  padding-bottom: 24px;
  .kampuspedia-seo-text {
    &__wrapper {
      padding: 24px 16px 0;

      hr {
        margin: 24px 0 16px;
      }
    }
    &__message {
      margin-bottom: 8px;
      .campus-markdown > .campus-markdown-content:last-of-type {
        margin-bottom: 0;
      }
    }
  }
  @media screen and (min-width: 768px) {
    padding-bottom: 40px;
    .kampuspedia-seo-text {
      &__wrapper {
        padding: 40px 0 0;
        hr {
          margin: 40px 0 24px;
        }
      }
      &__message {
        margin: 0;
      }
      &__show-more {
        display: none;
      }
    }
  }
`

const KampuspediaSeoText: FC = ({ children }) => {
  const theme: ThemeType = useTheme()
  const [isShownAll, setIsShownAll] = useState(false)
  return (
    <div className="kampuspedia-seo-text" css={kampuspediaSeoTextStyle(theme)}>
      <Container isMobileFull>
        <div className="kampuspedia-seo-text__wrapper">
          <NewTypography
            tagName="div"
            variant="paragraph"
            level="3"
            levelPC="1"
            className="kampuspedia-seo-text__message"
          >
            {isShownAll ? <MarkdownContent content={SeoText} /> : <Ellipsis text={SeoText} clamp={10} useMarkdown />}
          </NewTypography>
          <TextLink
            className="kampuspedia-seo-text__show-more"
            text={isShownAll ? 'Sembunyikan' : 'Selengkapnya'}
            onClick={(e) => {
              e.preventDefault()
              setIsShownAll(!isShownAll)
            }}
          />
          <Separator noMargin />
        </div>
        {children}
      </Container>
    </div>
  )
}

export default KampuspediaSeoText
